import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Select, SelectItem } from "@heroui/react";
import { useQuery } from "@tanstack/react-query";
import { UnplugIcon } from "lucide-react";
import { l2AccountAddressQuery } from "../../queries/aztec";
import { shortHex } from "../../utils";

export function ManualClaimInitialModal({
  isOpen,
  onClose,
  onContinue,
  claimNetwork,
  setClaimNetwork,
}: {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
  claimNetwork: "l1" | "l2";
  setClaimNetwork: (network: "l1" | "l2") => void;
}) {
  const { data: l2AccountAddress } = useQuery(l2AccountAddressQuery);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      isDismissable={false}
      isKeyboardDismissDisabled={true}
      classNames={{
        base: "turnstile-modal-border rounded-3xl",
        closeButton: "text-white text-xl top-4 right-5",
        header: "pt-5 pb-3",
        body: "items-center px-6 py-2 gap-4",
        backdrop: "turnstile-modal-backdrop",
      }}
    >
      <ModalContent>
        <ModalHeader className="flex flex-col items-start">
          <p className="text-lg font-semibold">Manual Claim</p>
          <p className="text-sm font-normal text-[#ADC0D0]">
            If you don't see your transaction or your funds didn't arrive correctly on the network, use manual claim.
          </p>
        </ModalHeader>
        <ModalBody>
          <Select
            fullWidth
            size="lg"
            label="Claim network"
            description="Select the network to which you have bridged your assets and in which you want to claim them."
            selectedKeys={[claimNetwork]}
            onSelectionChange={(keys) => setClaimNetwork(keys.anchorKey as "l1" | "l2")}
            classNames={{
              description: "text-[#A2B9C9]",
              trigger: "bg-[#3F6784] data-[hover=true]:bg-[#487292] p-4",
            }}
          >
            <SelectItem key="l1">Ethereum</SelectItem>
            <SelectItem key="l2">Aztec</SelectItem>
          </Select>
          <div className="space-y-1">
            <div className="flex items-center justify-between w-full border rounded-xl px-4 py-2">
              {l2AccountAddress ? (
                <>
                  <div>
                    <div className="text-sm font-normal text-[#ADC0D0]">Recipient address</div>
                    <div className="font-semibold">{shortHex(l2AccountAddress.toString())}</div>
                  </div>

                  <UnplugIcon className="text-[#F25858]" />
                </>
              ) : (
                <>
                  <div className="font-semibold">Recipient address</div>

                  <Button color="primary" radius="full" size="sm" className="font-semibold">
                    Connect wallet
                  </Button>
                </>
              )}
            </div>
            <div className="text-[#A2B9C9] text-xs">
              Recipient wallet address is automatically field based on your connected wallet.
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button fullWidth size="lg" color="primary" radius="full" isDisabled={!l2AccountAddress} onPress={onContinue}>
            Continue
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
